import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgPage } from "./-components/org.preview";

export const Route = createFileRoute("/_auth/org/$orgId/preview")({
  component: () => Page()
});

function Page() {
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/preview" });
  if (!org) {
    return <div>Org not found</div>;
  }
  return <OrgPage org={org} />;
}
